<template>
  <v-form ref="form" v-model="valid" lazy-validation class="full">
    <v-col class="md-hidden pager-row">
      <span class="back-button" @click="goBack">
        <i class="fas fa-chevron-left m-r-5"></i>
        Go Back
      </span>
      <radial-progress-bar
        :diameter="45"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :startColor="'#00A8C8'"
        :stopColor="'#00A8C8'"
        :innerStrokeColor="'#B0E5EF'"
        :strokeWidth="3"
        :innerStrokeWidth="3"
        class="right progress-bar"
      >
        <p><span>{{ completedSteps }}</span> of {{ totalSteps }}</p>
      </radial-progress-bar>
    </v-col>
    <div class="form-body col-md-8 col-12">
      <v-container>
        <v-row class="policy-container">
          <v-col cols="12" sm="12" md="12" class="header-div">
            <h3>Policy Details</h3>
          </v-col>

          <v-row class="form-item-section">
            <v-col cols="12" sm="12" md="6" class="input-wrapper">
              <v-list-item-title>
                Proposed insurance inception <span class="red-star">*</span>
              </v-list-item-title>
              <v-menu
                v-model="proposedDateFlag"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on:click:append="on; proposedDateFlag=true"
                    outlined
                    dense
                    append-icon=" "
                    color="primary"
                    placeholder="DD/MM/YY"
                    :rules="[rules.required, rules.dateValidation]"
                    :value="policyDetails.proposed_insurance_inception_date | moment"
                    @blur="formatDate($event, 'proposed_insurance_inception_date')"
                    maxlength="8"
                    validate-on-blur
                    ref="date"
                  />
                </template>
                <v-date-picker
                  v-model="policyDetails.proposed_insurance_inception_date"
                  no-title
                  locale="en-in"
                  color="primary"
                  @input="closeDatePicker"
                  :min="nowDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="input-wrapper">
              <v-list-item-title>
                Period of insurance
              </v-list-item-title>
              <v-text-field
                color="primary"
                solo
                outlined
                flat
                dense
                :disabled="true"
                :value="'12 months'"
              />
            </v-col>
          </v-row>

          <v-col cols="12" sm="12" md="12" class="header-div">
            <h3>Coverage</h3>
          </v-col>

          <v-row class="form-item-section">
            <v-col cols="12" sm="12" md="12" class="input-wrapper">
              <v-list-item-title>
                Type of insurance cover required <span class="red-star">*</span>
              </v-list-item-title>
              <v-radio-group
                :rules="[rules.required]"
                v-model="policyDetails.type_of_insurance"
              >
                <v-radio value="PL">
                  <template v-slot:label>
                    <span class="m-l-5"
                      >Physical damage and liability</span
                    >
                  </template>
                </v-radio>
                <v-radio value="L">
                  <template v-slot:label>
                    <span class="m-l-5">Liability only</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="12" md="6" class="input-wrapper">
              <v-list-item-title>
                Limit of third party liability <span class="red-star">*</span>
              </v-list-item-title>
              <v-select
                v-model="policyDetails.limit_third_party_liability"
                outlined
                dense
                color="primary"
                :items="_liablilityRequiredList"
                label="Select"
                item-text="value"
                item-value="key"
                :single-line="true"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" class="input-wrapper" v-if="parseFloat(yatchDetails.length) >= 23">
              <v-list-item-title>
                Will you require additional cover?
                <b class="bold">(for yachts longer than 23m in length)</b>
                <span class="red-star">*</span>
              </v-list-item-title>
              <v-radio-group
                :rules="[rules.required]"
                v-model="policyDetails.is_additional_cover_required"
              >
                <v-radio value="N">
                  <template v-slot:label>
                    <span class="m-l-5">No</span>
                  </template>
                </v-radio>
                <v-radio value="Y">
                  <template v-slot:label>
                    <span class="m-l-5"
                      >Yes, full P&I cover required</span
                    >
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-col
            cols="12"
            sm="12"
            md="12"
            class="header-div"
            v-if="yatchDetails.yacht_power_type === 'SY'"
          >
            <h3>Coverage – for sailing boat only</h3>
          </v-col>

          <v-row
            class="form-item-section"
            v-if="yatchDetails.yacht_power_type === 'SY'"
          >
            <v-col cols="12" sm="12" md="6" class="input-wrapper">
              <v-list-item-title>
                Will cover for masts spars, sails and running riggings against
                racing risks be required? <span class="red-star">*</span>
              </v-list-item-title>
              <v-select
                v-model="policyDetails.is_cover_sails"
                @change="
                  changeOtherBox($event, 'cover_sails_replacement_value')
                "
                outlined
                dense
                color="primary"
                :items="coverRequiredList"
                label="Select"
                item-text="value"
                item-value="key"
                :single-line="true"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
              class="input-wrapper"
              v-bind:class="{ hide: policyDetails.is_cover_sails !== 'Y' }"
            >
              <v-list-item-title>
                Total replacement value of these items ({{
                  insuredValue.currency
                }})
                <span class="red-star">*</span>
                <br />
                <b class="hide">&nbsp;.</b>
              </v-list-item-title>
              <v-text-field
                v-model="policyDetails.cover_sails_replacement_value"
                color="primary"
                @focus="removeComma('cover_sails_replacement_value')"
                @blur="formatPrice('cover_sails_replacement_value')"
                @keypress="isNumber($event)"
                solo
                outlined
                flat
                dense
                :rules="
                  policyDetails.is_cover_sails === 'Y'
                    ? [rules.required, rules.numberRule, rules.negativeValidation]
                    : []
                "
                maxLength="8"
              />
            </v-col>
          </v-row>

          <v-col
            cols="12"
            sm="12"
            md="12"
            class="header-div"
            v-if="yatchDetails.yacht_power_type === 'MY'"
          >
            <h3>Coverage – for power boat only</h3>
          </v-col>

          <v-row
            class="form-item-section"
            v-if="yatchDetails.yacht_power_type === 'MY'"
          >
            <v-col cols="12" sm="12" md="6" class="input-wrapper">
              <v-list-item-title>
                Will cover for sports be required? <span class="red-star">*</span>
                <br v-show="policyDetails.is_cover_sports === 'Y'"/>
                <b class="hide">&nbsp;.</b>
              </v-list-item-title>
              <v-select
                v-model="policyDetails.is_cover_sports"
                @change="
                  changeOtherBox($event, 'cover_sports_type', 'limit_liability')
                "
                name="cover_required_sport"
                outlined
                dense
                color="primary"
                :items="coverRequiredList"
                label="Select"
                item-text="value"
                item-value="key"
                :single-line="true"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
              class="input-wrapper"
              v-show="policyDetails.is_cover_sports === 'Y'"
            >
              <v-list-item-title>
                Types of sports (e.g. wakeboarding, doughnuts, banana boats,
                water skiing, etc.) <span class="red-star">*</span>
              </v-list-item-title>
              <v-text-field
                v-model="policyDetails.cover_sports_type"
                color="primary"
                solo
                outlined
                flat
                dense
                :rules="
                  policyDetails.is_cover_sports === 'Y' ? [rules.required] : []
                "
                maxLength="20"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
              class="input-wrapper"
              v-show="policyDetails.is_cover_sports === 'Y'"
            >
              <v-list-item-title>
                Limit of third party liability <span class="red-star">*</span>
              </v-list-item-title>
              <v-select
                v-model="policyDetails.limit_liability"
                outlined
                dense
                color="primary"
                :items="_liablilityLimitList"
                label="Select"
                item-text="value"
                item-value="key"
                :single-line="true"
                :rules="
                  policyDetails.is_cover_sports === 'Y' ? [rules.required] : []
                "
              />
            </v-col>
          </v-row>
        </v-row>
      </v-container>
    </div>

    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="!$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="goBack"
      >
        <span class="back-icon"></span>
        Previous Step
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="validateAndGoNext"
      >
        Continue
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="cancelChange"
      >
        <span class="back-icon"></span>
        Cancel Changes
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="applyChange"
      >
        Apply Changes
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapGetters, mapMutations } from "vuex";
import RadialProgressBar from "vue-radial-progress";
import PremiumApi from "@/plugins/axios";

export default {
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      valid: false,
      completedSteps: 5,
      totalSteps: 7,
      policyDetails: this.getPolicyDetails(),
      yatchDetails: this.getYatchDetails(),
      insuredValue: this.getInsuredValue(),
      proposedDateFlag: false,
      nowDate: new Date().toISOString().slice(0,10),
      rules: {
        required: (value) => !!value || "This field is mandatory",
        fileSize: (value) => this.photos > 0 || "Attached File is mandatory",
        numberRule: (value) => {
          const pattern = /^\d+$/;
          if (value == null || value == undefined) {
            return true;
          }
          return (
            pattern.test(
              String(value)
                .replace(/\,/g, "")
                .replace(/\-/g, "")
            ) || "This field must have numeric value"
          );
        },
        negativeValidation: (value) => {
          return parseFloat(value) >= 0 || "Value should not be negative";
        },
        emailValidation: (value) => {
          var pattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
          if (value == null || value === undefined || value === "") {
            return true;
          }
          return pattern.test(value) || "E-mail must be valid";
        },
        dateValidation: (value) => {
          if (value == null || value == undefined || value == "") {
            return true;
          }
          if (
            moment(value, "DDMMYY", true).isValid() ||
            moment(value, "DD/MM/YY", true).isValid()
          ) {
            const enteredDate = moment(value, "DDMMYY");
            const todayDate = moment(this.nowDate, "YYYY-MM-DD");
            if (enteredDate.diff(todayDate) >= 0) {
              return true;
            }
            return "Date cannot be a past date";
          }
          return "Invalid Date Format";
        },
      },
    };
  },
  filters: {
    moment: function(date) {
      var result = moment(date).format("DD/MM/YY");
      if (result === "Invalid date") {
        return "";
      } else {
        return moment(date).format("DD/MM/YY");
      }
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateAndGoNext: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("savePolicyDetails", this.policyDetails);
        this.$store.state.formPageNumber = 6;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    cancelChange: function() {
      this.$store.state.isEditMode = false;
      this.$store.state.formPageNumber = 7;
    },
    applyChange: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit("savePolicyDetails", this.policyDetails);
        this.$store.state.isEditMode = false;
        this.$store.state.formPageNumber = 7;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    goBack: function() {
      this.$store.state.formPageNumber = 4;
    },
    moment: function(e) {
      return moment();
    },
    getPolicyDetails: function() {
      return _.cloneDeep(this.$store.getters.getPolicyDetails);
    },
    getYatchDetails: function() {
      return _.cloneDeep(this.$store.getters.getYatchDetails);
    },
    getInsuredValue: function() {
      return _.cloneDeep(this.$store.getters.getInsuredValue);
    },
    changeOtherBox: function(e, key, key2) {
      if (e !== "N") {
        this.policyDetails[key] = null;
      }
      if (e !== "N" && key2) {
        this.policyDetails[key2] = null;
      }
    },
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + '/PolicyDetails';
      PremiumApi.logAccess(postData, function(data) {
        console.log('Data sent with : ' + JSON.stringify(postData));
      });
    },
    formatDate: function(e, key) {
      let date = e.target.value;
      if (
        moment(date, "DDMMYY", true).isValid() ||
        moment(date, "DD/MM/YY", true).isValid()
      ) {
        e.target.value = moment(date, "DDMMYY").format("DD/MM/YY");
        this.policyDetails[key] = moment(date, "DDMMYY").format("YYYY-MM-DD");
      }
    },
    isDateText: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      console.log(charCode);
      if (charCode > 31 && (charCode < 47 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    closeDatePicker: function() {
      this.proposedDateFlag = false;
      setTimeout(()=> {
        this.$refs.date.validate();
      }, 500);
      
    },
    removeComma(key) {
      this.policyDetails[key] = !this.policyDetails[key]
        ? null
        : this.policyDetails[key].replace(/,/g, "");
    },
    formatPrice(key) {
      this.policyDetails[key] = !this.policyDetails[key]
        ? null
        : parseFloat(this.policyDetails[key]).toLocaleString();
    },
  },
  mounted: function() {
    window.scrollTo(0, 0);
    this.trackPage();
  },
  computed: {
    ...mapGetters([
      "liablilityRequiredList",
      "liablilityLimitList",
      "coverRequiredList",
    ]),
    _liablilityRequiredList() {
      const currency = _.cloneDeep(this.$store.getters.getInsuredValue)
        .currency;
      if (this.liablilityRequiredList) {
        return this.liablilityRequiredList.filter((obj) => {
          return obj.currency === currency;
        });
      }
      return [];
    },
    _liablilityLimitList() {
      const currency = _.cloneDeep(this.$store.getters.getInsuredValue)
        .currency;
      if (this.liablilityLimitList) {
        return this.liablilityLimitList.filter((obj) => {
          return obj.currency === currency;
        });
      }
      return [];
    },
  },
};
</script>
